





















import traceQuery from '~/queries/trace.gql'
import { mountComponent } from 'library/helpers/dom'
import RegionModal from 'library/components/globals/modals/trace-region'

export default

	props:
		traceData: Object
		contentMap: Object

	data: ->
		loaded: false
		sectionData: {}

		tableHeading: [
			{
				title: 'Harvest Origin'
			},
			{
				title: '%'
			},
			{
				title: 'Harvest Year'
			}
		]

		rows: []

	fetch: ->
		@sectionData = await @$craft.getEntry
			query: traceQuery
			variables:
				section: 'trace'
				type: 'origins'
				slug: @contentMap.origins

		@loaded = true

		@$nextTick =>
			@createRows()


	computed:
		tableData: -> @rows

	methods:
		createRows: ->
			for item in @traceData?.countries
				@rows.push {
					cell1: @countryName(item)
					cell2: Math.round item.PctMix
					cell3: item.HY
				}

		countryName: (item) ->
			if item.COOCountry == 'United States'
				return 'California'
			else return item.COOCountry

		showRegion: (label) ->

			# show the correct California map
			formattedLabel = label
			if label == 'California' then formattedLabel = 'United States'

			filteredRegion = @traceData?.countries.filter (region) ->
				region.COOCountry == formattedLabel

			await mountComponent RegionModal,
				parent: this
				propsData:
					region: filteredRegion[0]


